import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Blogs from "./pages/Blogs";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BookingForm from "./components/BookingForm";
import ScrollToTop from "./components/ScrollToTop";
import BlogDetails from "./components/BlogDetails";
import ServiceDetails from "./components/ServicesDetail";
import PatientSafety from "./pages/PatientSafety";
import DentalTourism from "./pages/DentalTourism";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/demo" element={<BookingForm />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        <Route path="/services/:id" element={<ServiceDetails />} />
        <Route path="/patient-safety" element={<PatientSafety />} />
        <Route path="/dental-tourism" element={<DentalTourism />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
